import React, { type FC, type PropsWithChildren } from 'react';

type CheckmarkOutlineProps = {
  /** The color of the icon. */
  color?: string;
};

const CheckmarkOutline: FC<PropsWithChildren<CheckmarkOutlineProps>> = ({ color = '#D916A8' }) => (
  <svg fill="none" height="20" viewBox="0 0 24 20" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M1.64574 9.50414L4.26389 6.88654C4.67989 6.47001 5.35561 6.47001 5.77214 6.88654L8.55242 9.6668C8.96895 10.0828 9.64415 10.0828 10.0607 9.6668L17.9482 1.77987C18.3652 1.36227 19.0404 1.36227 19.457 1.77987L22.0751 4.39747C22.4916 4.81401 22.4916 5.48974 22.0751 5.90627L10.0607 17.9201C9.64415 18.3372 8.96895 18.3372 8.55242 17.9201L1.64574 11.0124C1.22921 10.5964 1.22921 9.92067 1.64574 9.50414Z"
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export default CheckmarkOutline;
